import { render, staticRenderFns } from "./Ruble.vue?vue&type=template&id=54db5e0f&"
var script = {}
import style0 from "./Ruble.vue?vue&type=style&index=0&id=54db5e0f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports